// src/utils/mappings.js

export const CATEGORIES = {
    0: {
        id: 0,
        titleKey: "translate.formuls_grid_title0",
        descKey: "translate.formuls_grid_subtitle0_small"
    },
    1: {
        id: 1,
        titleKey: "translate.formuls_grid_title1",
        descKey: "translate.formuls_grid_subtitle1_small"
    },
    2: {
        id: 2,
        titleKey: "translate.formuls_grid_title2",
        descKey: "translate.formuls_grid_subtitle2_small"
    },
    3: {
        id: 3,
        titleKey: "translate.formuls_grid_title3",
        descKey: "translate.formuls_grid_subtitle3_small"
    },
    4: {
        id: 4,
        titleKey: "translate.formuls_grid_title4",
        descKey: "translate.formuls_grid_subtitle4_small"
    },
    5: {
        id: 5,
        titleKey: "translate.formuls_grid_title5",
        descKey: "translate.formuls_grid_subtitle5_small"
    },
    6: {
        id: 6,
        titleKey: "translate.formuls_grid_title6",
        descKey: "translate.formuls_grid_subtitle6_small"
    },
    7: {
        id: 7,
        titleKey: "translate.formuls_grid_title7",
        descKey: "translate.formuls_grid_subtitle7_small"
    }
};